module.exports = __webpack_public_path__ + "static/media/nan.8b103b76.jpg";